import Badge from './badge';

export default Badge;



// WEBPACK FOOTER //
// ./src/components/elements/badge/index.js